export default __webpack_public_path__ + "static/media/55.262191bb.jpg";